/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div :style="[(expandWrapStyle)] | transRpxStyle" class="expand-wrap"><div class="expand"><template v-if="(!isTransfer)"><guide-tips pageType="makeOrderDetail" :trainInfo="(trainInfo)" v-if="(isPreScramble)"/><marke-order-guide :list="(trainInfo?.estimate_banner)" v-else/><div class="student-notice" v-if="(isStudent)"><div class="student-notice-left"><div class="student-notice-tag">学生优惠</div><div class="title">硬座/硬卧/二等座/无座席别可享学生优惠价格最终以实际占座成功的票价为准。</div></div></div><div :class='"es-seat-information"' :style="[(refactorTicketData.length <= 3 ? 'justify-content:space-between':'')] | transRpxStyle" v-if="(refactorTicketData && !isTransfer)"><div v-for="(item, index) in (refactorTicketData)" :key="item.index" class="es-card"><div class="es-ticket-left"><div class="es-seat-type-name"><div class="es-seat-type-name-text">{{ item.seat_type_name }}<div class="student-tag" v-if="(item.is_student)">学</div></div></div><mpx-view @tap="showTicketDetail(item)" class="es-ticket-price"><span class="appointment-tag" v-if="(item.is_student)">约</span><span class="es-ticket-price-num">￥{{ item.show_price }}</span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="7" height="4" viewBox="0 0 7 4" class="triangle-icon" v-if="(item.showSleeperSeat)"><g transform="matrix(1,-2.2348338291067193e-8,2.2348338291067193e-8,-1,-8.939335666040634e-8,8.000000312876736)"><path d="M4.00172,4.573392156438368L6.03254,6.894330156438368C6.40971,7.3253901564383685,6.10359,8.000000156438368,5.53082,8.000000156438368L1.46918,8.000000156438368C0.896406,8.000000156438368,0.590288,7.3253901564383685,0.967461,6.894330156438368L2.99828,4.573392156438368C3.26389,4.269840156438368,3.73611,4.269840156438368,4.00172,4.573392156438368" fill-opacity="1"/></g></svg><div class="coupon-desc" v-if="(item.discount_desc_text && item.ticket_num !== '无票')">{{item.discount_desc_text}}</div></mpx-view></div><div class="es-ticket-right"><div class="es-ticket-remainder"><div v-if="(isPreScramble)"></div><div :style='["color: #999999"] | transRpxStyle' v-else-if="(item.ticket_num === '无票' && !fromChangeTicket)">无票</div><div v-else>{{ item.ticket_num }}</div></div><mpx-view @tap.stop="selectSeat(item)"><template v-if="(fromChangeTicket)"><div :style="[(item.ticket_price && item.ticket_num !== '无票'? '':'background: #CCCCCC')] | transRpxStyle" class="es-ticket-btn">预订</div></template><template v-else><div :style='["background: #FF4129;"] | transRpxStyle' class="es-ticket-btn" v-if="(isPreScramble)">预约</div><div :style='["background: #FF4129;"] | transRpxStyle' class="es-ticket-btn" v-else-if="(item.ticket_num === '无票')">抢票</div><div class="es-ticket-btn" v-else>预订</div></template></mpx-view></div></div></div></template><div class="transfer-seat-information" v-else><seat-information v-for="(item, index) in (selectSeatInfo)" :class="(selectSeatInfo.length > 1 && 'seat-information')" :selectSeatInfo="(item)" :ticketData="(ticketData[index])" :seatInfoIndex="(index)" @show="openPriceEstimation" :isStudent="(isStudent)" @transferSeatCB="transferSeatCB"/></div><price-detail-info-alter :show="(showPriceEstimation)" :title="(priceEstimation.title)" :priceDetail="(priceEstimation.detail)" priceDetailCardTip="卧铺价格仅供参考，以实际出票结果收取费用" @close="closePriceEstimation" :customStyle="(lowerDrawer)"/></div></div><div :style="[(retractStyle)] | transRpxStyle" class="retract"><div class="left"><div v-for="(item, index) in (selectSeatInfo)" class="seat"><div class="number" v-if="(isTransfer)">{{ index + 1 }}</div><div class="type">{{ item?.seat_type_name ?? '' }}</div><div class="price">￥{{ item?.show_price ?? '' }}</div><div class="coupon-desc" v-if="(item.discount_desc && !isTransfer)">{{
          item?.discount_desc ?? ''
        }}</div></div></div><mpx-view @tap="triggerExpand" class="action">选坐席</mpx-view></div><Privacy :list="(baichuanTrainPrivacy)" @privacyVerify="privacyVerify" v-if="(showPrivacy)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mc99a6152"}'>
  @import '~@/mixins/stylus/color.styl'

  .expand-wrap
    display grid
    overflow hidden
    transition grid-template-rows 0.5s 0s, opacity 0.5s 0.1s
    grid-template-columns 100%
  .retract
    display flex
    flex-direction row
    align-items center
    justify-content space-between
    background #FFFFFF
    height 48px
    padding 0 23px 0 14px
    border-radius 8px
    transition height 0.3s 0s, opacity 0.3s 0.1s
    .left
      display flex
      flex-direction row
      align-items center
      .seat
        display flex
        align-items center
        flex-wrap wrap
        &:not(:last-child)
          margin-right 24px
        .number
          font-family Barlow Semi Condensed
          font-weight 400
          font-size 12px
          padding 0 8px
          line-height 22px
          color #666666
          margin-right 6px
          border-radius 6px
          background #F2F6F9
        .type
          font-family PingFangSC-Medium
          font-size 16px
          font-weight 500
          line-height 16px
          letter-spacing 0px
          color #333333
        .price
          font-family Barlow Semi Condensed
          font-size 18px
          font-weight 400
          line-height 18px
          text-align center
          letter-spacing 0px
          color #333333
        .coupon-desc
          margin-left 5px
          padding 1.5px 2px
          box-sizing border-box
          border 1px solid #CCCCCC
          border-radius 3px
          font-family PingFang SC
          font-size 9px
          font-weight normal
          line-height 9px
          text-align right
          letter-spacing 0px
          color #999999
    .action
      font-family PingFang SC
      font-size 14px
      font-weight normal
      line-height 14px
      text-align right
      letter-spacing 0px
      color #999999
      position relative
      &::after
        position absolute
        content ''
        right -11px
        top 4.5px
        width 8px
        height 4.5px
        background-image url('https://ut-static.udache.com/webx/sfc/bbrbRrhKu8Dh67eMxzptV.png')
        background-size contain
        background-repeat no-repeat
  .expand
    background #FFFFFF
    border-radius 8px
    min-height 0
  .student-notice
    font-size 12px
    font-weight 400
    color #999999
    margin 18px 18px 0px 14px
    display flex
    flex-direction row
    justify-content space-between
    align-items center
    .student-notice-left
      display flex
      flex-direction row
      justify-content flex-start
      align-items center
      flex 1
      .student-notice-tag
        font-size 10px
        line-height 13px
        font-weight normal
        font-family PingFang SC
        color #27BF6B
        width 44px
        height 14px
        margin-right 4px
        box-sizing border-box
        border 0.5px solid rgba(39, 191, 107, 0.6)
        border-radius 3px
        text-align center
      .title
        font-family PingFang SC
        font-size 12px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #666666
        flex 1
    .student-notice-right
      position relative
      font-family PingFang SC
      font-size 12px
      font-weight normal
      line-height 11px
      letter-spacing 0px
      color #666666
      &::after
        position absolute
        content ''
        right -9px
        top 1.5px
        width 4.5px
        height 8px
        background-image url('https://ut-static.udache.com/webx/sfc/u2SPUJglRdRt6P8oLrC8k.png')
        background-size contain
        background-repeat no-repeat
  .es-seat-information
    display flex
    flex-direction column
    justify-content flex-start
    white-space nowrap
    flex-wrap nowrap
    padding 0 14px 3px 14px
    background #FFFFFF
    border-radius 8px
    .es-card
      position relative
      box-sizing border-box
      display flex
      flex-direction row
      align-items center
      height 65px
      box-shadow none
      justify-content space-between
      border-bottom 0.5px solid #EEEEEE
      &:last-child
        border-bottom none
      .es-ticket-left
        display flex
        flex-direction row
        justify-content flex-start
        flex 1
        .es-seat-type-name
          font-size 16px
          text-align center
          display flex
          flex-direction row
          justify-content flex-start
          align-items center
          font-family PingFang SC
          font-weight 500
          line-height 16px
          letter-spacing 0px
          color #333333
          position relative
          min-width 72px
        .es-seat-type-name-text
          position relative
          display flex
          flex-direction row
          justify-content flex-start
          align-items center
          .student-tag
            font-size 10px
            line-height 14px
            font-weight normal
            font-family PingFang SC
            color #27BF6B
            width 14px
            height 14px
            margin-left 4px
            box-sizing border-box
            border 0.5px solid rgba(39, 191, 107, 0.6)
            border-radius 3px
            text-align center
            position absolute
            right -18px
        .es-ticket-price
          white-space nowrap
          display flex
          align-items center
          .appointment-tag
            color #ff6400
            font-size 12px
          .es-ticket-price-num
            display inline-block
            font-family Barlow Semi Condensed
            font-size 22px
            font-weight 400
            line-height 22px
            text-align center
            letter-spacing 0px
            color #FF6400
          .triangle-icon
            margin-left 2px
            fill #FF6400
          .coupon-desc
            margin-left 5px
            padding 1.5px 2px
            box-sizing border-box
            border 1px solid #FFBC91
            border-radius 3px
            font-family PingFang SC
            font-size 9px
            font-weight normal
            line-height 9px
            text-align right
            letter-spacing 0px
            color #FF6400
      .es-ticket-right
        display flex
        flex-direction row
        align-items center
        .es-ticket-remainder
          position relative
          margin-right 12px
          font-family PingFang SC
          font-size 14px
          font-weight normal
          line-height 16px
          letter-spacing 0px
          color #666666
        .es-ticket-btn
          background #FF6400
          width 65px
          height 33px
          border-radius 7px
          font-family PingFang SC
          font-size 14px
          font-weight 500
          line-height 33px
          text-align center
          letter-spacing 0px
          color #FFFFFF
    .es-seat-type-name
      color #1473FF
  .transfer-seat-information
    padding 14px 13px
    .seat-information
      &:not(:last-child)
        margin-bottom 10px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mc99a6152"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexc99a6152%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexc99a6152%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mc99a6152"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexc99a6152/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'price-detail-info-alter':getComponent(require("../price-detail-info-alter/index.mpx?isComponent&outputPath=components%2Findex853d8b3a%2Findex")),'Privacy':getComponent(require("../../pages/train-detail/components/privacy/index.mpx?isComponent&outputPath=components%2Findex6f368ef8%2Findex")),'seat-information':getComponent(require("../../pages/train-detail/components/seat-information/index.mpx?isComponent&outputPath=components%2Findex17fa8b3c%2Findex")),'guide-tips':getComponent(require("../../pages/search/components/guide-tips.mpx?isComponent&outputPath=components%2Fguide-tips99b597a0%2Findex")),'marke-order-guide':getComponent(require("../marke-order-guide/index.mpx?isComponent&outputPath=components%2Findex418cc4c8%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
